import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, OnInit, ViewChild, Input, Output, EventEmitter, Optional } from '@angular/core';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { SseService } from 'src/app/services/SseService';
import { TemaService } from 'src/app/services/tema.services';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { urlMercado } from 'src/app/utils/mercado-url.util';
import { listasServices } from 'src/app/services/listas.services';

@Component({
  selector: 'app-editar-lista',
  templateUrl: './editar-lista.component.html',
  styleUrls: ['./editar-lista.component.scss']
})
export class EditarListaComponent implements OnInit /*, AfterViewInit*/ {
  @Input() currentlistcfd = false; // <-- Input requerido por el template padre
  @Input() metaapi = false; // <-- Input requerido por el template padre
  @Input() idMercadoInicial: number | null = null; // <-- lista a editar cuando se llega vía /listas?id=
  @Output() save = new EventEmitter<{ id: number; name: string; items: any[] }>(); // <-- Output

  // Asegura inicialización explícita con arreglo vacío
  public companias = new CdkTableVirtualScrollDataSource<companiaLista>([]);
  displayedColumns: string[] = ['n', 'iso', 'descripcion', 'tipo', 'acciones'];
  @ViewChild('eliminarComp', { static: false }) eliminarCompViewport!: CdkVirtualScrollViewport;
  token: string;
  listaMercado: any;
  theme: string;
  selectedValue: any;
  nombreLista: string = '';

  constructor(private _sseservice: SseService, private _cookieService: CookieService, 
  public temaservicio: TemaService,private cdr: ChangeDetectorRef, public dialog: MatDialog,
  @Optional() public dialogRef: MatDialogRef<EditarListaComponent>,
     private toastr: ToastrService,private _listasService: listasServices,
    ){

  }

  ngOnInit(): void {
    this.token = this._cookieService.get('auth_token');
    this.temaservicio.valDarkTheme.subscribe(data => {
      this.theme = data ? 'dark-theme' : 'light-theme';
    });
    this.listarMercados();

    // Log para depuración
    console.log('[Init] companias inicial:', this.companias.data);

    this._listasService.vallistasEditarCompania$.subscribe(data => {
      console.log('[Stream] datos recibidos servicio:', data?.length, data);
      this.setCompanias(data);
    });
  }

  private setCompanias(data: companiaLista[]) {
    if (!Array.isArray(data)) {
      console.warn('setCompanias recibió algo no array');
      return;
    }
    // Reasignar .data con una copia: el setter del CdkTableVirtualScrollDataSource
    // compara por referencia, y el stream puede entregar el mismo array (p.ej. al añadir).
    this.companias.data = [...data];
    console.log('[Set] companias.data length:', this.companias.data.length);

    // Forzar refresco
    this.cdr.detectChanges();
    if (this.eliminarCompViewport) {
      setTimeout(() => this.eliminarCompViewport.checkViewportSize(), 0);
    }
  }

  listarMercados(){
    this._sseservice.apiPostNew("listamercadosporusuario", {}, this.token).subscribe({
      next: (data: any) => {
        console.log(data);
        this.listaMercado = data;

        // Si se llegó con /listas?id=<idmercado>, seleccionar y cargar esa lista automáticamente.
        if (this.idMercadoInicial != null && this.idMercadoInicial > 0) {
          const mercadoInicial = Array.isArray(this.listaMercado)
            ? this.listaMercado.find((m: any) => Number(m.idmercado) === Number(this.idMercadoInicial))
            : undefined;
          if (mercadoInicial) {
            this.selectedValue = mercadoInicial.idmercado;
            this.buscarCompania();
          } else {
            this.toastr.error('La lista indicada no está disponible para tu usuario', 'Error',
              { timeOut: 6000, positionClass: 'toast-top-center' });
          }
        }
      }
    });
  }

  eliminar(element: companiaLista) {
    
      this._listasService.updatelistasEditarCompania(this.companias.data.filter(item => item !== element));
        this.toastr.success('Compañía eliminada correctamente', 'OK', { timeOut: 7000, positionClass: 'toast-top-center' });
  
  }



  buscarCompania() {
    const jsonData = { idmercado: this.selectedValue };
    this._sseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
      next: (data: any) => {
        console.log('[API] listadecompaniaspormercado ->', data?.length);
        this._listasService.updatelistasEditarCompania(data); // centraliza flujo
        // Cargar el nombre de la lista actual si existe
        if (this.selectedValue && this.listaMercado) {
          const mercadoSeleccionado = this.listaMercado.find((m: any) => m.idmercado === this.selectedValue);
          if (mercadoSeleccionado) {
            this.nombreLista = mercadoSeleccionado.nombreLista || `${mercadoSeleccionado.iso}`;
          }
        }
      }
    });
  }

  EditarLista(){
    let url='editarlista';
    if(this.selectedValue>0){
      if (!this.nombreLista || this.nombreLista.trim() === '') {
        this.toastr.error('Debe ingresar un nombre para la lista', 'Error', { timeOut: 5000, positionClass: 'toast-top-center' });
        return;
      }

      const jsonData = {
        idmercado: this.selectedValue, 
        idnectums: this.companias.data,
        nombreLista: this.nombreLista.trim()
      };
      
      this._sseservice.apiPostNew(url, jsonData, this.token).subscribe({
            next: (data: any) => {
                if(data.status){
                  this.toastr.success(data.msg, 'OK', { timeOut: 7000, positionClass: 'toast-top-center' });
                }else{
                this.toastr.error(data.msg, 'Error', { timeOut: 7000, positionClass: 'toast-top-center' });
                }
              if (this.dialogRef) {
                this.dialogRef.close();
              }
              
            }
       });
        
    }else{
      const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '200px',
        panelClass: this.theme,
        data: {
          msj: 'Debe Seleccionar un Mercado para eliminar'
        }
      });
    }

  }

  actualizarViewport() {
    if (this.eliminarCompViewport) {
      this.eliminarCompViewport.checkViewportSize();
    }
    this.cdr.detectChanges();
  }

  /** Abre el activo en /mercados dentro del mercado seleccionado. */
  urlMercadoActivo(element: any): string {
    if (!this.selectedValue) { return '/mercados'; }
    const mercado = this.listaMercado?.find((m: any) => m.idmercado == this.selectedValue) ?? { idmercado: this.selectedValue };
    return urlMercado(mercado, element.iso ?? '');
  }
}
